module.exports = __webpack_public_path__ + "img/marketing-sample.72a3cbd1.jpeg";